<cc-box>
  <div class="container-responsive" header box translate>
    ACCOUNTS.BALANCE
  </div>
  <div content box>

    <form [formGroup]="immediateChargeForm" (ngSubmit)="submitImmediateCharge()">
      <div class="box-row">
        <div class="left">
          <span translate>SETTINGS.AUTO_RECHARGE.CURRENT_BALANCE</span>
          <span class="price">{{ (balance$ | async)?.balance?.monetary | currency:'USD':'symbol':'1.0' }}</span>
        </div>
        <div class="right right-container">
          <div class="currency-input-wrapper">
            <cc-dollar-sign></cc-dollar-sign>
            <input formControlName="amount" class="input currency-input" type="number" min="1">
          </div>
          <button mat-raised-button color="primary-full">{{ 'SETTINGS.CHARGE' | translate }}</button>
        </div>
      </div>
    </form>

    <form [formGroup]="autoRechargeForm" (ngSubmit)="submitAutoRecharge()">

      <div class="box-row">
        <div class="left">
          <span translate>SETTINGS.NOTIFICATIONS_ON_RECHARGE</span>
        </div>
        <div class="right">
          <ui-switch   (change)="switchAutoRecharge($event)" formControlName="enabled" ></ui-switch>
        </div>
      </div>

      <div class="box-row"   *ngIf="autoRechargeForm.get('enabled').value">
        <div class="left">
          <span translate>SETTINGS.AUTO_RECHARGE.AMOUNT_CHARGE</span>
        </div>
        <div class="right email-wrapper">
          <cc-dollar-sign></cc-dollar-sign>
          <div class="input-error">
            <input formControlName="amount" class="input currency-input" type="number" min="1">
            <cc-input-errors [form]="autoRechargeForm"

                             inputName="amount"
                             [errors]="[{'min':'ERRORS.INVALID_VALUE'}]"></cc-input-errors>
          </div>
          <button type="submit" mat-raised-button color="info-full"
                  class="notification-button">{{ 'SAVE' | translate }}</button>
        </div>
      </div>

    </form>
    <!-- TODO: feature put on hold -->
    <!--
    <div class="box-row-header" translate>
      SETTINGS.MONTHLY_SUBSCRIPTIONS
    </div>

    <div class="monthly-subscriptions-box">
      <div class="money-subscriptions-text">Lorem ipsum</div>
      <div class="flex">
        <cc-money-package-card
          class="flex-1"
          *ngFor="let packagePlan of packagePlans"
          [price]="packagePlan.priceCents / 100"
          [moneyToGet]="packagePlan.priceCents / 100 * packagePlan.factor"
          [savingsPercentage]="100 - (1 / packagePlan.factor * 100)"
          [currency]="packagePlan.currency"
        ></cc-money-package-card>
      </div>
      <div class="right">
        <button mat-raised-button color="primary-full">{{ 'PLANS.SUBSCRIBE' | translate }}</button>
      </div>
    </div>
    -->

    <form [formGroup]="notificationsForm" (ngSubmit)="submitNotifications()">
      <div class="box-row-header" translate>
        SETTINGS.NOTIFICATIONS
      </div>

      <div class="box-row">
        <div class="left">
          <span translate>SETTINGS.NOTIFICATIONS_ON</span>
        </div>
        <div class="right">
          <ui-switch formControlName="lowBalanceEnabled"></ui-switch>
        </div>
      </div>

      <div class="box-row">
        <div class="left">
          <span translate>SETTINGS.NOTIFICATIONS_BALANCE</span>
        </div>
        <div class="right right-container">
          <div class="currency-input-wrapper">
            <cc-dollar-sign></cc-dollar-sign>
            <input formControlName="lowBalanceThreshold" class="input currency-input" type="number" min="1">
          </div>
        </div>
      </div>

      <div class="box-row email-section">
        <div class="left">
          <span translate>EMAIL_ADDRESS</span>
        </div>
        <div class="right email-wrapper">
          <div class="input-error">
            <input
              formControlName="email"
              placeholder="{{ 'EMAIL' | translate }}"
              class="input input-long"
              type="email">
            <cc-input-errors
              [form]="notificationsForm"
              inputName="email"
              [errors]="[{'required': 'ERRORS.REQUIRED'}, {'pattern': 'ENTER_VALID_EMAIL'}]">
            </cc-input-errors>
          </div>
          <button
            type="submit"
            mat-raised-button
            color="info-full"
            class="notification-button"
          >{{ 'SAVE' | translate }}</button>
        </div>
      </div>

    </form>

  </div>
</cc-box>
